import { Type } from 'class-transformer';
import { ConveyanceSellerAssignedBillingRulesResultDto } from './conveyance-seller-assigned-billing-rules-result-dto';

export class ConveyanceClosingDateValidationResultDto {
    @Type(() => ConveyanceSellerAssignedBillingRulesResultDto)
    sellerCommunityAssignedBillingRules: ConveyanceSellerAssignedBillingRulesResultDto[];

    closingPaperworkFileExists: boolean;
}
